import React from "react";

const FormInputLayout = ({ label, formikName, children, required, labelPosition }) => {
    return (
        <div className="row px-0 mx-0 form-input-container center-alignment">
            <div className="col-md-4 px-0 mx-0" style={{ textAlign: labelPosition && labelPosition }}>
                <label htmlFor={formikName} className="fs-6 text-gray-300 fw-400 mb-2 mb-lg-0">
                    {label}
                    {required !== false && <span className="text-red-500">&#42;</span>}
                </label>
            </div>
            <div className="col-md-8 px-0 mx-0 pb-1">{children}</div>
        </div>
    );
};

export default FormInputLayout;
